import {Injectable, OnDestroy} from '@angular/core';
import {fromEvent, merge, Observable, Subject, Subscription, timer} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {of} from 'rxjs/internal/observable/of';

@Injectable({
    providedIn: 'root'
})
export class IdleService implements OnDestroy {
    private idleSubject = new Subject<void>();
    onIdle$: Observable<void> = this.idleSubject.asObservable();

    private activity$: Observable<Event|null> = merge(
        of<Event|null>(null),
        fromEvent(document, 'mousemove'),
        fromEvent(document, 'mousedown'),
        fromEvent(document, 'keydown'),
        fromEvent(document, 'touchstart'),
        fromEvent(document, 'scroll')
    );

    onActivity$: Observable<Event | null> = this.activity$;

    private idleSub?: Subscription;
    private activitySub?: Subscription;

    startWatching(idleTimeMs: number): void {
        this.stopWatching();

        // Log e reinício do timer a cada evento de atividade
        this.activitySub = this.activity$.subscribe(event => {
            if (event) {
                console.log('watching3: Atividade detectada: ' + idleTimeMs, event.type);
            }
        });

        this.idleSub = this.activity$
            .pipe(switchMap(() => timer(idleTimeMs)))
            .subscribe(() => this.idleSubject.next());
    }

    stopWatching(): void {
        this.idleSub?.unsubscribe();
        this.idleSub = undefined;
        this.activitySub?.unsubscribe();
        this.activitySub = undefined;
    }

    ngOnDestroy(): void {
        this.stopWatching();
    }
}
